import { Avatar, Box, Typography } from "@mui/material";
import { useAuth } from "hooks/useAuth";

const Manager = () => {
  const { line_manager } = useAuth();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "left",
        px: "12px",
        py: "7px",
      }}
    >
      <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 800, opacity: 0.9 }}>
        Manager
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Avatar
          src={line_manager?.profile_image}
          alt={`${line_manager?.first_name} ${line_manager?.last_name}`}
          sx={{ width: 30, height: 30 }}
        />
        <Typography variant="h6" sx={{ fontSize: "16px", marginLeft: "12px", color: "#146ED2" }}>
          {line_manager && line_manager.first_name} {line_manager && line_manager.last_name}
        </Typography>
      </Box>
    </Box>
  );
};

export default Manager;
